var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"root",style:(_vm.scssProps)},[_c('img',{staticClass:"avatar",attrs:{"src":_vm.src,"alt":_vm.name},on:{"load":_vm.handleLoad,"error":_vm.handleError}}),_vm._v(" "),(!_vm.imageLoaded)?_c('div',{staticClass:"initials"},[_vm._v("\n    "+_vm._s(_vm.initials)+"\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }